'use client';

import ContactForm from './ContactForm';
import { FiMail, FiMapPin, FiClock } from 'react-icons/fi';

export const dynamic = 'force-dynamic';

export default function ContactPage() {
  // Use your ReCAPTCHA site key from env
  const recaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';

  return (
    <main className="min-h-screen bg-white dark:bg-zinc-950 pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          
          {/* Left Column: The Hook */}
          <div className="space-y-12">
            <header className="space-y-6">
              <div className="flex items-center gap-3">
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500"></span>
                </span>
                <span className="text-[10px] font-black uppercase tracking-[0.4em] text-emerald-600 dark:text-emerald-400">
                  Available for new signals
                </span>
              </div>
              <h1 className="text-6xl md:text-8xl font-black tracking-tighter text-zinc-900 dark:text-white leading-[0.9]">
                Let's <br /> <span className="text-indigo-600">Connect.</span>
              </h1>
              <p className="text-xl text-zinc-500 dark:text-zinc-400 max-w-md leading-relaxed">
                Have a project in mind or just want to talk shop? Drop a message and let's start a transmission.
              </p>
            </header>

            {/* Quick Info Bits */}
            <div className="space-y-8 pt-8 border-t border-zinc-100 dark:border-zinc-900">
              <ContactInfoItem 
                icon={<FiMail />} 
                label="Direct Message" 
                value="contact@ericagyei.com" 
              />
              <ContactInfoItem 
                icon={<FiMapPin />} 
                label="Location" 
                value="Remote / Halifax, NS" 
              />
              <ContactInfoItem 
                icon={<FiClock />} 
                label="Response Time" 
                value="Within 24-48 Hours" 
              />
            </div>
          </div>

          {/* Right Column: The Terminal (Form) */}
          <div className="relative">
            <div className="absolute -inset-4 bg-indigo-500/5 rounded-[3rem] blur-2xl" />
            {/* Pass ReCAPTCHA key to ContactForm */}
            <ContactForm recaptchaSiteKey={recaptchaSiteKey} />
          </div>

        </div>
      </div>
    </main>
  );
}

function ContactInfoItem({ icon, label, value }: { icon: React.ReactNode; label: string; value: string }) {
  return (
    <div className="flex items-center gap-4">
      <div className="p-3 rounded-2xl bg-zinc-50 dark:bg-zinc-900 text-indigo-500 border border-zinc-100 dark:border-zinc-800">
        {icon}
      </div>
      <div>
        <p className="text-[10px] font-black uppercase tracking-widest text-zinc-400">{label}</p>
        <p className="text-sm font-bold text-zinc-900 dark:text-zinc-100">{value}</p>
      </div>
    </div>
  );
}
